import axiosInstance from '../config/axios';

/**
 * Get current user's coin balance
 */
export const getMyCoinBalanceApi = () =>
  axiosInstance.get('/my-coin-balance').then((res) => res.data);

/**
 * Get active coin plans
 */
export const getCoinPlansApi = () =>
  axiosInstance.get('/coin-plans').then((res) => res.data);

/**
 * Get a specific coin plan by ID
 * @param {string} id 
 */
export const getCoinPlanByIdApi = (id) =>
  axiosInstance.get(`/coin-plans/${id}`).then((res) => res.data);
